import { useRedux } from 'hooks/index';
import { purchaseUserCreate } from '../../redux/user/purchase/actions';
import { UserPurchaseNew } from '../../types/user/purchase';

export default function usePurchase() {
    const { dispatch, appSelector } = useRedux();

    const { loading, apiPurchaseSuccess, error } = appSelector((state) => ({
        loading: state.UserPurchase.loading,
        apiPurchaseSuccess: state.UserPurchase.apiPurchaseSuccess,
        error: state.UserPurchase.error,
    }));

    const userPurchaseEntity = (data: UserPurchaseNew) => {
        dispatch(purchaseUserCreate(data));
    };

    return {
        apiPurchaseSuccess,
        userPurchaseEntity,
        error,
        loading,
    };
}
